import { LocalizedField } from './LocalizedField'
export class Configuration {
  constructor (params = {}) {
    this.currency = params.currency ? params.currency : '€'
    this.welcomeText = params.welcome_text ? new LocalizedField(params.welcome_text) : null
    this.thankyouText = params.thankyou_text ? new LocalizedField(params.thankyou_text) : null
    this.refundAvailable = params.refund_available || false
    this.logo = params.logo ? params.logo : null
    this.name = params.name ? params.name : null
    this.bankAccountType = params.bank_account_type ? params.bank_account_type : 'IBAN'
    this.availableDocumentTypes = params.available_document_types && params.available_document_types.length > 0 ? params.available_document_types : ['NATIONAL_ID_CARD','PASSPORT']
  }
}
